module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "Calisto MT",
      "font-size": "18pt",
      "letter-spacing": "1px",
      "padding-top": "75px",
      "padding-bottom": "25px"
    }
  }, [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("I acknowledge all the girls and women out there who have had trouble in the dating world. Further, I acknowledge that there are a number of men out there who deem it necessary and appropriate to give females advice on what they need to change, or do differently, in order to attract men. Really?! Why can the male not be responsible for any change necessary in order to keep up with the modern female? That is my question.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0